import { create } from "zustand";

export interface RecentResult {
  id: string;
  name: string;
  url: string;
  createdAt: number;
}

export interface PendingCloudAsset {
  assetId: string;
  name: string;
  mime: string;
  bytes: number;
}

interface DocumentState {
  pendingFiles: File[];
  pendingCloudAssets: PendingCloudAsset[];
  recentResults: RecentResult[];
  setPendingFiles(files: File[]): void;
  setPendingCloudAssets(assets: PendingCloudAsset[]): void;
  addRecentResult(result: RecentResult): void;
}

export const useDocumentStore = create<DocumentState>((set) => ({
  pendingFiles: [],
  pendingCloudAssets: [],
  recentResults: [],
  setPendingFiles: (pendingFiles) => set({ pendingFiles }),
  setPendingCloudAssets: (pendingCloudAssets) => set({ pendingCloudAssets }),
  addRecentResult: (result) => set((state) => ({ recentResults: [result, ...state.recentResults].slice(0, 8) }))
}));
